<template>
  <div>
    <el-form :inline="true" class="style1">
      <el-form-item>
        <el-button class="el-icon-circle-plus-outline" type="primary" size="mini" @click="dialogVisible = true">{{$t("general.add")}}
        </el-button>
      </el-form-item>
    </el-form>

    <el-table v-loading="loading" :data="tableData" highlight-current-row border style="width: 100%" :empty-text="$t('general.empty_data')">
      <el-table-column :label="$t('general.employee_id')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.employee_id }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('empPDF.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('empPDF.gender')" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.gender }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('empPDF.birthday')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.birthday | formatDate }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('empPDF.begin_date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.begin_date | formatDate }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="350">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t("general.edit")}}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t("general.delete")}}</el-button>
          <el-button size="mini" type="success" icon="el-icon-success" @click="printPDF(scope.$index, scope.row)">
            {{$t("general.print")}}</el-button>
          <!-- <el-button size="mini" type="success" icon="el-icon-view" @click="preview(scope.$index, scope.row)" plain>
          </el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!--adding new-->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="72%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="210px" class="demo-ruleForm" size="medium" style="margin-left:20px" :label-position="labelPosition">
        <el-input type="hidden" v-model="ruleForm.id" />
        <el-row>
          <el-col>
            <div style="padding-bottom:10px; color:red;">
              *最初に社員番号を選択してください。<br>
               &nbsp;
              社員の氏名（氏名フリガナ）、性別、生年月日、雇入年月日、業務の種類、現住所は社員番号により自動反映するため、編集できません。
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item :label="$t('general.employee_id')" prop="employee_id">
                <el-select v-model="ruleForm.employee_id" style="margin-left:10px;width: 185px" size="mini" :no-data-text="$t('general.empty_data')" @change="employeeIdSelected" :placeholder="$t('general.select')">
                  <el-option v-for="item in empList" :key="item.id" :label="item.employee_id" :value="item.employee_id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('empPDF.name')" prop="name">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.name" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.name')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empPDF.gender')" prop="gender">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.gender" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.gender')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empPDF.begin_date')" prop="begin_date">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.begin_date" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.begin_date')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empPDF.dismiss_date')" prop="dismiss_date">
                <el-date-picker v-model="ruleForm.dismiss_date" size="mini" value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date" :placeholder="$t('empPDF.dismiss_date')">
                </el-date-picker>
              </el-form-item>

              <el-form-item :label="$t('empPDF.history')" prop="history">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.history" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.history')"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <el-form-item>
                <span>
                  <br />
                </span>
              </el-form-item>

              <el-form-item :label="$t('empPDF.name_frgn')" prop="name_frgn">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.name_frgn" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.name_frgn')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empPDF.birthday')" prop="birthday">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.birthday" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.birthday')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empPDF.work_content')" prop="work_content">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.work_content" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.work_content')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empPDF.dismiss_reason')" prop="dismiss_reason">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.dismiss_reason" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.dismiss_reason')"></el-input>
              </el-form-item>

              <div style="padding-top:5px;">
              <el-form-item :label="$t('general.remark')" prop="remark">
                <el-input type="textarea" :rows="4" prefix-icon="el-icon-edit" v-model="ruleForm.remark" size="mini" style="margin-left:10px;width: 185px;" :placeholder="$t('general.remark')"></el-input>
              </el-form-item>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <div>
              <el-form-item :label="$t('empPDF.address')" prop="address">
                <el-input prefix-icon="el-icon-info" :value="'〒'+ruleForm.post_code+'  '+ruleForm.address1+ruleForm.address2+ruleForm.address3" size="mini" style="margin-left:10px;width: 705px" :placeholder="$t('empPDF.address')" readonly></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addUser('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}}</el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <!--edit-->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="72%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="210px" class="demo-ruleForm" size="medium" style="margin-left:20px" :label-position="labelPosition">
        <el-input type="hidden" v-model="ruleForm.id" />

        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item :label="$t('general.employee_id')" prop="employee_id">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.employee_id" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.employee_id')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empPDF.name')" prop="name">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.name" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.name')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empPDF.gender')" prop="gender">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.gender" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.gender')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empPDF.begin_date')" prop="begin_date">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.begin_date" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.begin_date')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empPDF.dismiss_date')" prop="dismiss_date">
                <el-date-picker v-model="ruleForm.dismiss_date" size="mini" value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date" :placeholder="$t('empPDF.dismiss_date')">
                </el-date-picker>
              </el-form-item>

              <el-form-item :label="$t('empPDF.history')" prop="history">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.history" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.history')"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <el-form-item>
                <span>
                  <br />
                </span>
              </el-form-item>

              <el-form-item :label="$t('empPDF.name_frgn')" prop="name_frgn">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.name_frgn" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.name_frgn')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empPDF.birthday')" prop="birthday">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.birthday" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.birthday')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empPDF.work_content')" prop="work_content">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.work_content" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.work_content')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empPDF.dismiss_reason')" prop="dismiss_reason">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.dismiss_reason" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.dismiss_reason')"></el-input>
              </el-form-item>

              <el-form-item :label="$t('general.remark')" prop="remark">
                <el-input type="textarea" :rows="4" prefix-icon="el-icon-edit" v-model="ruleForm.remark" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('general.remark')"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <div>
              <el-form-item :label="$t('empPDF.address')" prop="address">
                <el-input prefix-icon="el-icon-info" :value="'〒'+ruleForm.post_code+'  '+ruleForm.address1+ruleForm.address2+ruleForm.address3" size="mini" style="margin-left:10px;width: 705px;" :placeholder="$t('empPDF.address')" readonly></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateUser('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}}</el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <br />
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange"></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      labelPosition: "left",
      value: "",
      empList: [{
        id: "",
        employee_id: "",
        name: "",
        name_frgn: "",
        gender: "",
        birthday: "",
        post_code: "",
        address1: "",
        address2: "",
        address3: "",
        begin_date: "",
        work_content: "",
      },],
      empList1: [],
      ruleForm: {
        id: "",
        history: "",
        dismiss_date: "",
        dismiss_reason: "",
        remark: "",
        employee_id: "",

        name: "",
        name_frgn: "",
        gender: "",
        birthday: "",
        post_code: "",
        address1: "",
        address2: "",
        address3: "",
        begin_date: "",
        work_content: ""
      },
      rules: {
        employee_id: [{
          required: true,
          message: this.$t("companyInfo.fill"),
          trigger: "blur",
        },],
        name: [{
          required: true,
          message: this.$t("companyInfo.fill"),
          trigger: "blur",
        },],
      },
      tableData: [],
      search: "",
      dialogVisible: false,
      dialogUpdate: false,
      pageSize: 6,
      currentPage: 1,
      total: 0,
      disablePage: false,
      loading:false,
    };
  },
  methods: {
    preview(index, row) {
      
        var uid = window.localStorage.getItem('LoginUserId');
        window.open("/pdf/労働者名簿-" + row.name + "uid=" + uid + ".pdf");
      
    },
    employeeIdSelected() {
      let postData = this.qs.stringify({
        employee_id: this.ruleForm.employee_id,
      });
      this.axios({
        method: "post",
        url: "/ListEmpList",
        data: postData,
      })
        .then((response) => {
          this.empList1 = response.data;
          this.emp = this.empList1[0];
          this.ruleForm.name = this.emp.name;
          this.ruleForm.name_frgn = this.emp.name_frgn;
          this.ruleForm.gender = this.emp.gender;
          this.ruleForm.birthday = this.emp.birthday;
          this.ruleForm.post_code = this.emp.post_code;
          this.ruleForm.address1 = this.emp.address1;
          this.ruleForm.address2 = this.emp.address2;
          this.ruleForm.address3 = this.emp.address3;
          this.ruleForm.begin_date = this.emp.begin_date;
          this.ruleForm.work_content = this.emp.work_content;
          this.ruleForm.dismiss_date = this.emp.end_date;
          this.ruleForm.dismiss_reason = this.emp.cause;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    printPDF(index, row) {
      this.loading = true;
      let postData = this.qs.stringify({
        id: row.id,
      });
      this.axios({
        method: "post",
        url: "/empPDFprint",
        data: postData,
      })
        .then((response) => {
          this.$message({
            type: "success",
            message: this.$t("general.print_completed"),
          });
          setTimeout(()=>{this.preview(index, row);},700);
          this.loading = false;
        })
        .catch((error) => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed"),
          });
          this.loading = false;
          console.log(error);
        });
    },
    handleEdit(index, row) {
      this.dialogUpdate = true;
      this.ruleForm = Object.assign({}, row);
    },
    handleClose(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then((_) => {
          this.emptyUserData();
          done();
        })
        .catch((_) => { });
    },
    handleDelete(index, row) {
      this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: "OK",
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then(() => {
          let postData = this.qs.stringify({
            id: row.id,
          });
          this.axios({
            method: "post",
            url: "/deleteEmpPDF",
            data: postData,
          })
            .then((response) => {
              // this.getPages();
              // this.currentPage = 1;
              let postData = this.qs.stringify({
                page: this.currentPage,
              });
              this.axios({
                method: "post",
                url: "/pageEmpPDF",
                data: postData,
              })
                .then((response) => {
                  this.tableData = response.data;
                })
                .catch((error) => {
                  console.log(error);
                });
              this.$message({
                type: "success",
                message: this.$t("general.delete_completed"),
              });
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("general.canceled"),
          });
        });
    },
    handleCurrentChange() {
      let postData = this.qs.stringify({
        page: this.currentPage,
      });
      this.axios({
        method: "post",
        url: "/pageEmpPDF",
        data: postData,
      })
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    s1_cancel(ruleForm) {
      this.dialogUpdate = false;
      this.dialogVisible = false;
      this.emptyUserData();
      this.$refs[ruleForm].resetFields();
    },
    cancel() {
      this.dialogUpdate = false;
      this.dialogVisible = false;
      this.emptyUserData();
    },
    emptyUserData() {
      this.ruleForm = {
        id: "",
        history: "",
        dismiss_date: "",
        dismiss_reason: "",
        remark: "",
        employee_id: "",

        name: "",
        name_frgn: "",
        gender: "",
        birthday: "",
        post_code: "",
        address1: "",
        address2: "",
        address3: "",
        begin_date: "",
        work_content: "",
      };
    },
    addUser(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            history: this.ruleForm.history,
            dismiss_date: this.ruleForm.dismiss_date,
            dismiss_reason: this.ruleForm.dismiss_reason,
            remark: this.ruleForm.remark,
            employee_id: this.ruleForm.employee_id,
          });
          this.axios({
            method: "post",
            url: "/insertEmpPDF",
            data: postData,
          })
            .then((response) => {
              this.axios
                .post("/pageEmpPDF")
                .then((response) => {
                  this.tableData = response.data;
                  this.currentPage = 1;
                  this.$message({
                    type: "success",
                    message: this.$t("general.add_completed"),
                  });
                })
                .catch((error) => {
                  this.$message({
                    type: "warning",
                    message: this.$t("general.add_failed"),
                  });
                  console.log(error);
                });
              this.getPages();
              this.dialogVisible = false;
              // console.log(response);
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message.error('必須項目が入力されていません');
          return false;
        }
      });
    },
    updateUser(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            id: this.ruleForm.id,
            history: this.ruleForm.history,
            dismiss_date: this.ruleForm.dismiss_date,
            dismiss_reason: this.ruleForm.dismiss_reason,
            remark: this.ruleForm.remark,
            employee_id: this.ruleForm.employee_id,
          });
          this.axios({
            method: "post",
            url: "/updateEmpPDF",
            data: postData,
          })
            .then((response) => {
              this.handleCurrentChange();
              this.s1_cancel(ruleForm);
              this.$message({
                type: "success",
                message: this.$t("general.edit_completed"),
              });
              // console.log(response);
            })
            .catch((error) => {
              this.$message({
                type: "warning",
                message: this.$t("general.edit_failed"),
              });
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message.error('必須項目が入力されていません');
          return false;
        }
      });
    },
    getPages() {
      this.axios
        .post("/rowsEmpPDF")
        .then((response) => {
          this.total = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    refreshData() {
      location.reload();
    },
  },
  created() {
    this.axios
      .post("/pageEmpPDF")
      .then((response) => {
        // console.log(response.data);
        this.tableData = response.data;
      })
      .catch((error) => {
        console.log(error);
      });

    this.axios
      .post("/rowsEmpPDF")
      .then((response) => {
        this.total = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    this.axios
      .post("/ListEmpListForInsNameChange")
      .then((response) => {
        // console.log(response.data);
        this.empList = response.data;
        // console.log(this.empList);
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>

<style>
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
  width: 90px;
}

.btn-custom-confirm {
  width: 90px;
}
</style>
<style scoped>
.search_name {
  width: 200px;
}

.pages {
  margin: 0px;
  padding: 0px;
  text-align: right;
}

.style1 {
  margin-right: 130px;
  padding: 0px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/EmpPDF.vue